// ─────────────────────────────────────────────────────────────────────────
// COUCHE 3 (INTERIM) — Classement des candidatures côté organisateur.
//   ⚠️ Ceci n'est PAS encore le `getTrustScore()` décrit dans la note experte :
//   c'est un score de QUALITÉ DE PROFIL (catégorie/docs/expérience/médias/région).
//   La réputation (40%), la fiabilité (25%) et le boost payant (15%) NE SONT PAS
//   encore branchés — décision Max (2026-07-15) : « attendre les modules ».
//   À remplacer par un vrai trust score (réputation + prior médian cold-start +
//   règle anti-gaming du boost) quand les modules Évaluations/Fiabilité/Boost
//   seront livrés. Ne pas confondre avec la Couche 2 (utils/matching/relevance).
// ─────────────────────────────────────────────────────────────────────────

export interface ScoreBreakdown {
  category: number;    // max 30
  documents: number;   // max 20
  experience: number;  // max 20
  media: number;       // max 20
  region: number;      // max 10
}

export interface MatchScore {
  total: number;
  breakdown: ScoreBreakdown;
  label: 'Excellent' | 'Bon' | 'Moyen' | 'Faible';
  color: string;
  bgColor: string;
}

const EXP_SCORE: Record<string, number> = {
  premier: 5,
  emergeant: 10,
  confirme: 15,
  expert: 20,
};

export function computeMatchScore(stand: any, festival: any): MatchScore {
  const breakdown: ScoreBreakdown = {
    category: 0,
    documents: 0,
    experience: 0,
    media: 0,
    region: 0,
  };

  // 1. Catégorie (30 pts) — type du stand dans la liste acceptée par le festival
  const festivalTypes: string[] = festival.standTypes || [];
  if (stand.standType && festivalTypes.includes(stand.standType)) {
    breakdown.category = 30;
  }

  // 2. Documents légaux (20 pts)
  if (stand.insuranceUrl) breakdown.documents += 12;
  if (stand.kbisUrl) breakdown.documents += 8;

  // 3. Expérience (20 pts)
  breakdown.experience = EXP_SCORE[stand.experienceRange] || 0;

  // 4. Médias (20 pts)
  const photoCount = stand.galleryUrls?.length || 0;
  if (photoCount >= 3) breakdown.media += 10;
  else if (photoCount >= 1) breakdown.media += 5;
  if (stand.videoUrl) breakdown.media += 7;
  if (stand.pressKitUrl) breakdown.media += 3;

  // 5. Région (10 pts) — même région que le festival
  if (stand.region && festival.region && stand.region === festival.region) {
    breakdown.region = 10;
  }

  const total = Object.values(breakdown).reduce((a, b) => a + b, 0);

  let label: MatchScore['label'] = 'Faible';
  let color = 'text-red-400';
  let bgColor = 'bg-red-500/10 border-red-500/20';

  if (total >= 80) {
    label = 'Excellent';
    color = 'text-green-400';
    bgColor = 'bg-green-500/10 border-green-500/20';
  } else if (total >= 60) {
    label = 'Bon';
    color = 'text-[#FF5C00]';
    bgColor = 'bg-[#FF5C00]/10 border-[#FF5C00]/20';
  } else if (total >= 40) {
    label = 'Moyen';
    color = 'text-yellow-400';
    bgColor = 'bg-yellow-500/10 border-yellow-500/20';
  }

  return { total, breakdown, label, color, bgColor };
}
